import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Navbar } from "../components/site/Navbar";
import { Footer } from "../components/site/Footer";
import { MenuList } from "../components/site/MenuList";

export default function MenuPage() {
  const [items, setItems] = useState([]);
  const [settings, setSettings] = useState({});

  useEffect(() => {
    api.get("/menu").then((r) => setItems(r.data));
    api.get("/settings").then((r) => setSettings(r.data));
  }, []);

  return (
    <div className="min-h-screen bg-background" data-testid="menu-page">
      <Navbar />
      <main className="mx-auto max-w-7xl px-5 py-16 md:px-10 md:py-24">
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-copper">The Full Menu</p>
        <h1 className="mt-4 max-w-2xl font-serif text-4xl font-black leading-[1.05] tracking-tight text-cream sm:text-5xl lg:text-6xl">
          Freshly Brewed.<br />Freshly Baked.
        </h1>
        <p className="mt-5 max-w-xl text-base text-cream/60 md:text-lg">
          Every item is made to order. Prices are being finalised — tap a category to explore.
        </p>
        <div className="mt-12">
          <MenuList items={items} />
        </div>
      </main>
      <Footer settings={settings} />
    </div>
  );
}
